<template>
  <div class="Bases h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="bases"
      :options="options"
      :options2="options2"
      :func1="this.links"
      :func2="this.type"
      filter1="Influences"
      filter2="iLvl"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Two-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Bases",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "influences",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "itemLevel",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },

        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "Elder", value: "elder", disabled: false },
        { text: "Shaper", value: "shaper", disabled: false },
        { text: "Hunter", value: "hunter", disabled: false },
        { text: "Crusader", value: "crusader", disabled: false },
        { text: "Redeemer", value: "redeemer", disabled: false },
        { text: "Warlord", value: "warlord", disabled: false },
      ],
      options2: [
        { text: "All", value: "All", disabled: false },
        { text: "86+", value: "86", disabled: false },
        { text: "85", value: "85", disabled: false },
        { text: "84", value: "84", disabled: false },
        { text: "83", value: "83", disabled: false },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        let path = `https://www.pathofexile.com/trade/search/${this.$parent.league}?q=`;

        switch (item.influences) {
          case "shaper":
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null},"shaper_item":{"option":"true"}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;
          case "elder":
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null},"elder_item":{"option":"true"}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;

          case "redeemer":
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null},"redeemer_item":{"option":"true"}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;
          case "hunter":
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null},"hunter_item":{"option":"true"}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;
          case "crusader":
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null},"crusader_item":{"option":"true"}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;
          case "warlord":
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null},"warlord_item":{"option":"true"}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;

          default:
            path += `{"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"misc_filters":{"filters":{"ilvl":{"min":${item.itemLevel},"max":null}},"disabled":false}}},"sort":{"price":"asc"}}`;
            break;
        }
        return path;
      }
    },
    links(val, item) {
      if (item.influences.includes(val)) {
        return true;
      }
      return false;
    },
    type(val, item) {
      if (item.itemLevel == val) {
        return true;
      }
      return false;
    },
  },
};
</script>
